import { combineReducers } from 'redux';

import { reducer as beatbox, storeKey as beatboxKey } from './beatboxDuck';
import { reducer as beatboxFlows, storeKey as beatboxFlowsKey } from './beatboxFlowsDuck';
import { reducer as deployedFlows, storeKey as deployedFlowsKey } from './deployedFlows';
import {
  reducer as flowAccessesDiscrepancies,
  storeKey as flowAccessesDiscrepanciesKey,
} from './flowAccessesDiscrepanciesDuck';
import { reducer as flowAccesses, storeKey as flowAccessesKey } from './flowAccessesDuck';
import { reducer as flowSummary, storeKey as flowSummaryKey } from './flowSummary';
import { reducer as flowTraces, storeKey as flowTracesKey } from './flowTraces';
import { reducer as lookupTables, storeKey as lookupTablesKey } from './lookupTables';
import { reducer as metrics, storeKey as metricsKey } from './metricsDuck';
import { reducer as organizationUsers, storeKey as organizationUsersKey } from './organizationUsersDuck';
import { reducer as payloads, storeKey as payloadsKey } from './payloadsDuck';
import { reducer as reporting, storeKey as reportingKey } from './reportingDuck';
import { reducer as resource, storeKey as resourceKey } from './resource';
import { reducer as resources, storeKey as resourcesKey } from './resources';
import { reducer as resourceTypes, storeKey as resourceTypesKey } from './resourceTypes';
import { reducer as secrets, storeKey as secretsKey } from './secrets';
import { reducer as serviceAccounts, storeKey as serviceAccountsKey } from './serviceAccountsDuck';

const heartbeat = combineReducers({
  [deployedFlowsKey]: deployedFlows,
  [metricsKey]: metrics,
  [flowTracesKey]: flowTraces,
  [serviceAccountsKey]: serviceAccounts,
  [flowAccessesKey]: flowAccesses,
  [flowAccessesDiscrepanciesKey]: flowAccessesDiscrepancies,
  [flowSummaryKey]: flowSummary,
  [payloadsKey]: payloads,
  [resourcesKey]: resources,
  [resourceKey]: resource,
  [resourceTypesKey]: resourceTypes,
  [reportingKey]: reporting,
  [organizationUsersKey]: organizationUsers,
  [secretsKey]: secrets,
  [beatboxKey]: beatbox,
  [lookupTablesKey]: lookupTables,
  [beatboxFlowsKey]: beatboxFlows,
});

export default heartbeat;
